import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import "./SignUp.scss";
import {
  ERROR_MESSAGES,
  REGEX,
} from "../../../Utilities/Constants/Validations";
import LanguageIcon from "@mui/icons-material/Language";
import { useTranslation } from "react-i18next";
import { setLanguage } from "../../../Services/Redux/Reducer/Reducer";
import {
  API_RESPONSE,
  AUTHENTICATION_LABELS,
  COMMON_CONSTANTS,
  I18_TRANSLATION_COMMON,
  LANGUAGES,
  LAYOUTS,
  NUMBER_CONSTANTS,
  ROUTES,
  STORAGE_KEYS,
  TOASTER_CONFIGS,
  VALIDATION_CONSTANT,
} from "../../../Utilities/Constants/Constants";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isValidPhoneNumber } from "libphonenumber-js";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import { SetSessionStorageData, clearSessionStorage } from "../../../Services/Helpers/Helper";
import { toast } from "react-toastify";
import signupBanner from "../../../../Assets/Registration/signup_banner.svg"
const SignUp = () => {
  const { t, i18n } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [signupMode, setSignUpMode] = useState(STORAGE_KEYS.EMAIL);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [validPhoneNumber, setValidPhoneNumber] = useState(true);

  /* Navigatoin hook**/
  const navigate = useNavigate();
  /* Toggle language**/
  const changeLanguage = (languageCode: string) => {
    dispatch(
      setLanguage(
        language === LANGUAGES.ENGLISH ? LANGUAGES.ARABIC : LANGUAGES.ENGLISH
      )
    );
    i18n.changeLanguage(languageCode);
  };
  /* set and get language from redux**/
  const dispatch = useDispatch();
  const language: any = useSelector((state: any) => {
    return state.languageReducer.language;
  });

  /* Signup validation schema */
  const SignUpValidationSchema = yup.object({
    email: yup
      .string()
      .required(ERROR_MESSAGES.EMAIL_REQUIRED)
      // .matches(REGEX.EMAIL, ERROR_MESSAGES.INVALID_EMAIL)
      .email(ERROR_MESSAGES.INVALID_EMAIL)
      .trim(),
  });

  /* Phone validation schema */
  const PhoneValidationSchema = yup.object({
    phone_number: yup.string(),
  });

  /* Handling mode state */
  const onChangeMode = () => {
    signupMode === STORAGE_KEYS.EMAIL
      ? setSignUpMode(STORAGE_KEYS.MOBILE)
      : setSignUpMode(STORAGE_KEYS.EMAIL);
  };

  /* Handling phone number validation */
  const validatePhoneNumber = (e: any) => {
    isValidPhoneNumber(e);
    isValidPhoneNumber(e) === API_RESPONSE.TRUE
      ? setValidPhoneNumber(API_RESPONSE.TRUE)
      : setValidPhoneNumber(API_RESPONSE.FALSE);
    return isValidPhoneNumber(e);
  };

  /* Signup API call */
  const onSubmit = (loginType: any, payload: any) => {
    axiosInstance.post(API_END_POINTS.CREATE_ACCOUNT + `?${STORAGE_KEYS.LOGIN_TYPE}=` + loginType, payload).then((response: any) => {
      if (response.data.status === API_RESPONSE.TRUE) {
        toast.success(response.data.message, TOASTER_CONFIGS);
        navigate(ROUTES.OTP_VERIFICATION);
      }
    })
  }

  /* Payload and calling API function */
  const onCreateAccount = (value: any) => {
    clearSessionStorage();
    SetSessionStorageData(STORAGE_KEYS.MODE, AUTHENTICATION_LABELS.SIGN_UP);
    if (signupMode === STORAGE_KEYS.EMAIL) {
      let payload = {
        email: value.email.trim(),
        roles: `${NUMBER_CONSTANTS.FOUR}`
      };
      onSubmit(NUMBER_CONSTANTS.ONE, payload);
      SetSessionStorageData(STORAGE_KEYS.LOGIN_TYPE, NUMBER_CONSTANTS.ONE);
      SetSessionStorageData(STORAGE_KEYS.EMAIL, value.email);

    } else {
      if (validatePhoneNumber(phoneNumber.split(COMMON_CONSTANTS.PLUS).length > NUMBER_CONSTANTS.ONE ? phoneNumber : COMMON_CONSTANTS.PLUS + phoneNumber)) {
        let payload = {
          phone_number: phoneNumber.split(COMMON_CONSTANTS.PLUS).length > NUMBER_CONSTANTS.ONE ? phoneNumber : COMMON_CONSTANTS.PLUS + phoneNumber,
          roles: `${NUMBER_CONSTANTS.FOUR}`
        }
        onSubmit(NUMBER_CONSTANTS.ZERO, payload);
        SetSessionStorageData(STORAGE_KEYS.LOGIN_TYPE, NUMBER_CONSTANTS.ZERO);
        SetSessionStorageData(STORAGE_KEYS.PHONE_NUMBER, phoneNumber.split(COMMON_CONSTANTS.PLUS).length > NUMBER_CONSTANTS.ONE ? phoneNumber : COMMON_CONSTANTS.PLUS + phoneNumber);
      }
    }
  }

  return (
    <div
      className="row signup-wrapper"
      dir={language === LANGUAGES.ENGLISH ? LAYOUTS.LTR : LAYOUTS.RTL}
    >
      <div className="col-md-6 logo-contents">
        <img className="login-banner" src={signupBanner} />
      </div>
      <div
        className={
          language === LANGUAGES.ENGLISH
            ? "col-md-6 column-wrap"
            : "col-md-6 column-wrap-rtl"
        }
      >
        <div className="row language_switch_header">
          <div className="language_switch_contianer">
            <LanguageIcon className="language_icon" />
            <button
              className="language_button"
              onClick={() => {
                changeLanguage(
                  language === LANGUAGES.ENGLISH
                    ? LANGUAGES.ARABIC_ABBRIVATION
                    : LANGUAGES.ENGLISH_ABBRIVATION
                );
              }}
            >
              {language === LANGUAGES.ENGLISH
                ? LANGUAGES.ARABIC
                : LANGUAGES.ENGLISH}
            </button>
          </div>
        </div>

        <div className="form-wrapup">
          <div className="form-contents">
            <h2 className="form-heading">{t('Create Account')}</h2>
            <Formik
              initialValues={signupMode === STORAGE_KEYS.EMAIL
                ? { email: "" }
                : { phone_number: "" }}
              validationSchema={
                signupMode === STORAGE_KEYS.EMAIL
                  ? SignUpValidationSchema
                  : PhoneValidationSchema
              }
              onSubmit={(values, actions) => {
                onCreateAccount(values);
              }}
            >
              {(formik) => {
                return (
                  <div>
                    {signupMode === STORAGE_KEYS.EMAIL && (
                      <div className="form-items">
                        <label className="form-label">{t('Email Address')}</label>
                        <Field
                          name={STORAGE_KEYS.EMAIL}
                          className="email-input"
                          placeholder={t("Enter Email Address")}
                          onKeyPress={(event: any) => {
                            if (event.key === VALIDATION_CONSTANT.KEY_TYPE) {
                              formik.handleSubmit();
                            }
                          }}
                        />
                        <div className="errorMessage">
                          {formik.touched.email && formik.errors.email && (
                            <p>{t(`${formik.errors.email}`)}</p>
                          )}
                        </div>
                      </div>
                    )}

                    {signupMode === STORAGE_KEYS.MOBILE && (
                      <div className="form-items">
                        <label className="form-label">{t('Phone Number')}</label>
                        <PhoneInput
                          inputProps={language === LANGUAGES.ENGLISH ? {
                            className: "input email-input phone_num_input",
                            name: "phone_number",
                          } :
                            {
                              className: "input phone_num_input-rtl",
                              name: "phone_number",
                            }
                          }
                          countryCodeEditable={false}
                          country={"ae"}
                          enableSearch={true}
                          value={phoneNumber}
                          onChange={(e: any) => {
                            setPhoneNumber(e);

                            validatePhoneNumber("+" + e);

                          }}
                        />
                        <div className="errorMessage">
                          {validPhoneNumber === false && (
                            <p>{t("Please enter valid phone number")}</p>
                          )}
                        </div>
                      </div>
                    )}

                    <button
                      className="btn create-btn"
                      type="submit"
                      onClick={() => {
                        formik.handleSubmit();
                      }}
                    >
                      {t('Create Account')}
                    </button>
                  </div>
                );
              }}
            </Formik>

            <p id="conditions-text">
              {t('By continuing, you agree to Learn&Play’s')}{" "}
              <span id="bold-text">{t('Terms of Service')}</span> &{" "}
              <span id="bold-text">{t('Privacy Policy')}</span>
            </p>

            <p id="conditions-text">
              {t('Already have an account?')}{" "}
              <span className="login-text" onClick={() => { navigate(ROUTES.LOGIN) }}>{t('Log in')}</span>
            </p>

            <p id="conditions-text">- {t('OR')} -</p>

            <div className="alternative-btn-wrap">
              <button className="btn alternative-btn" onClick={onChangeMode}>
                {signupMode === "email"
                  ? t("Sign up with phone number")
                  : t("Sign up with email")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUp;

function dispatch(arg0: any) {
  throw new Error("Function not implemented.");
}
